import type { ReactNode } from 'react';
import { useState } from 'react';

import clsx from 'clsx';
import { XIcon } from 'lucide-react';

import { Button } from './button';

type BannerProps = {
  type: 'warning' | 'success';
  children?: ReactNode;
  enableClose?: boolean;
  onClose?: () => void;
};

const BANNER_STYLES = {
  warning: 'bg-yellow-500',
  success: 'bg-green-500',
};

export function Banner(props: BannerProps) {
  const { type, children, onClose, enableClose = true } = props;
  const [show, setShow] = useState(true);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className={clsx(
        'flex items-center gap-x-6 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 rounded',
        BANNER_STYLES[type]
      )}
    >
      <div className="text-sm leading-6 text-white w-full">{children}</div>
      <div className="flex flex-1 justify-end">
        {enableClose ? (
          <Button variant="ghost" size="icon" className="-m-3 p-3" onClick={handleClose}>
            <span className="sr-only">Dismiss</span>
            <XIcon />
          </Button>
        ) : null}
      </div>
    </div>
  );
}
